export const SET_OVERLOADED = "SET_OVERLOADED";

export const setOverloaded = (value) => {
    return {
        type: SET_OVERLOADED,
        payload: {value}
    };
};